module.exports = __webpack_public_path__ + "static/media/down.0f244717.svg";